import NaptimeResource from './NaptimeResource';

class UserAccountDelete extends NaptimeResource {
  static RESOURCE_NAME = 'userAccountDelete.v1';
}

export default UserAccountDelete;
